const imgUrl = "https://img.riverbaymart.com/";
const homeImgUrl = "https://img.riverbaymart.com/a/";
// const apiUrl = "https://testtxxzdata.tingxiangzu.com/Web/";
const apiUrl = "https://txxzdata.galaxyemall.com/Web/";
const baseUrl = "https://img.riverbaymart.com/";
const serviceTelephone = 13522315820;
const platformName = "江湾甄选";
export {
    apiUrl,
    imgUrl,
    homeImgUrl,
	baseUrl,
    serviceTelephone,
    platformName
}